document.addEventListener('change',function(e){
  var s=e.target.closest('[data-variant-select]');if(!s)return;
  var o=s.options[s.selectedIndex],f=s.closest('[data-product]');
  f.querySelector('[data-price]').textContent=o.dataset.price;
  f.querySelector('[data-compare]').textContent=o.dataset.compare||'';
  var b=f.querySelector('[data-buy]');b.disabled=o.dataset.available!=='true';
  b.textContent=o.dataset.available==='true'?'Add to Cart':'Sold out';
});
document.addEventListener('click',function(e){
  var a=e.target.closest('[data-scroll]');if(!a)return;
  var t=document.querySelector(a.dataset.target);if(t)t.scrollBy({left:a.dataset.scroll*300,behavior:'smooth'});
});
(function(){
  var h=document.querySelector('[data-hero]');if(!h)return;
  var s=h.querySelectorAll('.slide'),d=h.querySelectorAll('.dots button'),i=0,t;
  function go(n){i=(n+s.length)%s.length;s.forEach(function(x,k){x.classList.toggle('on',k===i)});d.forEach(function(x,k){x.classList.toggle('on',k===i)});}
  function auto(){clearInterval(t);if(s.length>1&&!matchMedia('(prefers-reduced-motion:reduce)').matches)t=setInterval(function(){go(i+1)},6000);}
  h.querySelectorAll('[data-hero-go]').forEach(function(b){b.addEventListener('click',function(){go(i+ +b.dataset.heroGo);auto();});});
  d.forEach(function(b,k){b.addEventListener('click',function(){go(k);auto();});});
  if(s.length<2)h.querySelectorAll('.arr,.dots').forEach(function(x){x.hidden=true});auto();
})();
